import { action } from '@ember/object';
import { service } from '@ember/service';

import type { PopupData, Service } from 'webapp-types';

import PopupInnerModalComponent from 'webapp/components/popup/inner/modal';
import SubmitButtonComponent from 'webapp/components/submit-button';

export default class BillingPopupAnnualCommitmentInfoComponent extends PopupInnerModalComponent<PopupData.None> {
	@service('billing') declare billingService: Service.Billing;

	@action
	openUrl(): void {
		window.open(this.billingService.annualCommitmentCallUrl, '_blank');
	}

	<template>
		<div class="title">Downgrade unavailable during commitment</div>

		<div class="content">
			<p>
				You're currently in a commitment period, so downgrading your plan isn't available
				right now. If your needs have changed, our team can help explore your options.
			</p>

			<div class="controls2">
				<div class="controls2__right">
					<SubmitButtonComponent
						@text="Close"
						@theme="grey-empty"
						@noDelay={{true}}
						@onTrigger={{this.close}}
					/>
					<SubmitButtonComponent
						@text="Talk to our team"
						@noDelay={{true}}
						@onTrigger={{this.openUrl}}
					/>
				</div>
			</div>
		</div>
	</template>
}
